function injectStyle (ssrContext) {
  require("!!vue-loader/node_modules/vue-style-loader!css-loader?minimize!../../../../../node_modules/.13.7.1@vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-71a57ac8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/.13.7.1@vue-loader/lib/selector?type=styles&index=0!./ImagePreviewBox.vue")
}
var normalizeComponent = require("!../../../../../node_modules/.13.7.1@vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../../../node_modules/.13.7.1@vue-loader/lib/selector?type=script&index=0!./ImagePreviewBox.vue"
import __vue_script__ from "!!babel-loader!../../../../../node_modules/.13.7.1@vue-loader/lib/selector?type=script&index=0!./ImagePreviewBox.vue"
/* template */
import __vue_template__ from "!!../../../../../node_modules/.13.7.1@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-71a57ac8\",\"hasScoped\":true,\"buble\":{\"transforms\":{}}}!../../../../../node_modules/.13.7.1@vue-loader/lib/selector?type=template&index=0!./ImagePreviewBox.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71a57ac8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/packages/components/messageBox/components/ImagePreviewBox.vue
// module id = 70
// module chunks = 0 1